export default __webpack_public_path__ + "static/media/red-no-logo.643ed986.png";